import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function ClosingSection() {
  return <section className="w-full py-32 bg-gradient-to-b from-turquoise to-deepBlue px-4 relative overflow-hidden" data-id="element-17">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 w-[800px] h-[800px] bg-softViolet/20 rounded-full blur-[120px] -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-18" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-coralOrange/20 rounded-full blur-[100px] translate-x-1/2 translate-y-1/2 pointer-events-none" data-id="element-19" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-20">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight max-w-3xl" data-id="element-21">
          Transformá tu cursada y viví la universidad{' '}
          <span className="text-goldenYellow" data-id="element-22">sin estrés</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-white/90 max-w-2xl mb-16 font-medium leading-relaxed" data-id="element-23">
          Más de 500 estudiantes ya tienen su MegaPack. La cursada no espera.
          Vos tampoco deberías.
        </motion.p>

        <motion.a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} whileHover={{
        scale: 1.05,
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }} whileTap={{
        scale: 0.98
      }} className="bg-goldenYellow text-deepBlue font-bold text-2xl md:text-3xl px-12 py-6 rounded-full shadow-2xl transition-all duration-300 mb-8 w-full md:w-auto inline-block text-center no-underline" data-id="element-24">
          ¡Quiero el MegaPack ahora! →
        </motion.a>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex items-center gap-2 text-white/80 font-medium text-lg bg-black/20 px-6 py-3 rounded-full backdrop-blur-sm" data-id="element-25">
          <ClockIcon className="w-5 h-5 text-coralOrange" data-id="element-26" />
          <span data-id="element-27">El precio vuelve a $39.999 muy pronto. Aprovechá ahora.</span>
        </motion.div>
      </div>
    </section>;
}